import React from 'react';

const Section3 = ({ entry }) => (
  <div className="col-xs-3">
    <div>{entry.phone}</div>
    <div>{entry.fax}</div>
    <div>{entry.website}</div>
    <div>{entry.email}</div>
  </div>
);

export default Section3;
